import { type JSX } from 'react';
import { TdsToast } from '@scania/tegel-react';
import styles from './style.module.scss';

export type ToastVariants = 'success' | 'warning' | 'error';

export interface ToastProperties {
  readonly header?: string;
  readonly message: string;
  readonly variant?: ToastVariants;
  readonly dataTestId?: string;
}

const ToastContainer = ({ header, variant = 'success', message, dataTestId }: ToastProperties): JSX.Element => (
  <div className={styles['toast-container']} data-testid={dataTestId}>
    <TdsToast variant={variant} header={header} subheader={message} role="alert" />
  </div>
);

export default ToastContainer;
